import { invokeApi } from '../../bl_libs/invokeApi';
import { use_e2ee } from '../../utils/utils';
import { LOCAL_STORAGE_KEYS } from '../../utils/constants';

export const checkUsernamePrefixService = async (prefix) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi(
        {
            path: `/dq_insider/dqin/client/section/username_prefix/check?prefix=${encodeURIComponent(prefix)}`,
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        },
        use_e2ee(),
    );
};

/**
 *  section license pool after class save. */
export const silentAssignSectionPool = (orgCode, sectionCode, count) => {
    try {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        const base = process.env.REACT_APP_MYDQ_API;
        return fetch(`${base}/dq_insider/dqin/client/section/assign_licenses`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ org_code: orgCode, section_code: sectionCode, license_count: count }),
        }).catch(() => {});
    } catch {
        return Promise.resolve();
    }
};
